import $ from 'jquery';
import inView from './in-view';
import mobileMenu from './mobile-menu';
import menuBlob from './menu-blob';
import stickyHeader from './sticky-header';
import masonry from './masonry';
import banner from './banner';
import embedMessage from './embed-message';
import sideMenu from './sidemenu';
import toggleSidemenu from './toggle-sidemenu';

$(document).ready(() => {
    const $observeInView = $('.js-observe-in-view');
    if ($observeInView.length) {
        inView('.js-observe-in-view');
    }

    const $jsMobileMenu = $('.js-toggle-menu');
    if ($jsMobileMenu.length) {
        $jsMobileMenu.map((i, v) => mobileMenu(v));
    }

    const $header = $('.header');
    if ($header.length) {
        $header.map((i, v) => stickyHeader(v));
    }

    const $menu = $('.js-menu');
    if ($menu.length) {
        $menu.map((i, v) => menuBlob(v));
    }

    const $masonry = $('.js-masonry');
    if ($masonry.length) {
        $masonry.map((i, v) => masonry(v));
    }

    const $banner = $('.js-banner');
    if ($banner.length) {
        $banner.map((i, v) => banner(v));
    }

    const $embedMessage = $('.js-embed-message');
    if ($embedMessage.length) {
        $embedMessage.map((i, v) => embedMessage(v));
    }

    const $toggleSidemenu = $('.js-sidemenu-toggler');
    if ($toggleSidemenu.length) {
        $toggleSidemenu.map((i, v) => toggleSidemenu(v));
    }

    if (document.querySelector('.js-sidemenu')) {
        new sideMenu();
    }
    
});
